require('./mortgageRequestOperativeDocumentationView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @ components
const { MortgageRequestOperativeDocumentation } = require('components/mortgageRequest/mortgageRequestOperativeDocumentation/mortgageRequestOperativeDocumentation');

class MortgageRequestOperativeDocumentationView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { match: { params: { contractId } }, immLoans } = this.props;
        const alias = immLoans.getIn(['byId', contractId, 'alias']);

        const mappingBreadcrumb = [
            {
                text: formatText('mortgageRequestCommons-init'),
                url: '/myprofile/global'
            },
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: alias,
                url: `/myprofile/documentation/contracts/mortgages/${contractId}`
            },
            {
                text: formatText('mortgageRequestOperativeDocumentation-documentation'),
                url: `/myprofile/documentation/contracts/mortgages/${contractId}/documents`
            }
        ];

        return (
            <div className="mortgage-request-operative-documentation-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestOperativeDocumentation-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-8">
                                <MortgageRequestOperativeDocumentation />
                            </div>
                            <div className="mortgage-request-operative-documentation-view__commercial-ads col-xs-3 col-xs-offset-1">
                                <CommercialAds path="documentation/contracts/mortgages/:contractId/documents" type="wafer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestOperativeDocumentationView.propTypes = {
    immLoans: PropTypes.object,
    match: PropTypes.object
};

module.exports.constructor = MortgageRequestOperativeDocumentationView;

module.exports.MortgageRequestOperativeDocumentationView = connect(state => ({ immLoans: state.loans }), null)(MortgageRequestOperativeDocumentationView);
